import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiModule } from './ui/ui.module';
import { FormatMoneyPipe } from './pipe/format-money/format-money.pipe';
import { LimitToPipe } from './pipe/limit-to/limit-to.pipe';
import { HttpClientModule } from '@angular/common/http';
import { FecthDataService } from './service/fetchservice/fetchservice';
import { AuthService } from './service/auth/auth.service';
import { LocalStorageService } from './service/storage/localstorage.service';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccountModule } from '../account/account.module';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { PagesModule } from '../pages/pages.module';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { CalendarComponent } from '../pages/calendar/calendar.component';
import { ChatComponent } from '../pages/chat/chat.component';
import { ProfilComponent } from '../account/auth/profil/profil.component';
import { NgPipesModule } from 'ngx-pipes';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DndModule } from 'ngx-drag-drop';
import { FullCalendarModule } from '@fullcalendar/angular';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { SimplebarAngularModule } from 'simplebar-angular';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorModule } from 'primeng/paginator';
import { ListAdministrateursComponent } from '../pages/component/administrateur/list-administrateurs/list-administrateurs.component';
import { AddAdministrateursComponent } from '../pages/component/administrateur/add-administrateurs/add-administrateurs.component';
import { UpdateAdministrateurComponent } from '../pages/component/administrateur/update-administrateur/update-administrateur.component';
import { DashboardComponent } from '../pages/component/dashboard/dashboard.component';
import { CartService } from './service/cartService/cart.service';
import { NotificationService } from './service/notification/notification.service';

@NgModule({
  declarations: [

    //end
    //DateFormatPipe,
    DashboardComponent,
    CalendarComponent,
    ChatComponent,
    ProfilComponent,
    FormatMoneyPipe,
    LimitToPipe,
  ],
  imports: [
    CommonModule,
    UiModule,
    HttpClientModule,
    MessagesModule ,
    ToastModule ,
    ButtonModule,
    RippleModule,
    FormsModule,
    NgxUiLoaderModule,
    FormsModule,
    NgPipesModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    DndModule,
    NgPipesModule,
    NgbNavModule,
 
    FullCalendarModule,
    LeafletModule,
    SimplebarAngularModule,
    ToastModule,
    NgxUiLoaderModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    PaginatorModule
  ],
  exports: [
    FormatMoneyPipe,
    LimitToPipe,

  ],
  providers: [
    FecthDataService,
    AuthService,
    LocalStorageService,
    AuthService,
    MessageService,
    ConfirmationService,
    CartService ,
    NotificationService
  ]
})
export class SharedModule { }
